import { render, staticRenderFns } from "./report-button.vue?vue&type=template&id=880d6466&lang=pug&"
import script from "./report-button.vue?vue&type=script&lang=js&"
export * from "./report-button.vue?vue&type=script&lang=js&"
import style0 from "./report-button.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports